"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.desktop = void 0;
var desktop = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 160v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.desktop = desktop;